/**
 * @flow
 */

import styled from 'react-emotion'
import colors from '../../../../themes/Colors'
import {
  mobile,
  tablet,
  customDevice,
  minDeviceWidth
} from '../../../../utils/mixins'
import {
  Typo16VeryLightPinkDR,
  Typo15PumpkinOrangeDR,
  Typo15VeryLightPinkDR
} from '../../../../themes/Fonts/Din2014'
import { Typo32PumpkinOrangeBNRI } from '../../../../themes/Fonts/Nort'

export const MapDescriptionSectionContainer = styled('div')`
  font-size: 1em;
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${mobile} {
    font-size: 1.143em;
    width: 90%;
    margin-left: 1.25em;
    margin-right: 1.25em;
    padding-top: 3.75em;
    padding-bottom: 3.75em;
  }
  ${tablet} {
    width: 90%;
    margin: auto;
    padding-top: 3.75em;
    padding-bottom: 3.75em;
    margin-left: 3em;
    margin-right: 3em;
  }
  ${customDevice(1024, 1239)} {
    width: 49.5%;
    padding-left: 3.75em;
    padding-right: 1.688em;
    padding-top: 30px;
    padding-bottom: 30px;
    min-height: ${props => (props.isSuper30Page ? '20em' : '38em')};
  }
  ${minDeviceWidth(1240)} {
    width: 49.5%;
    padding-left: 3.75em;
    padding-right: 4.688em;
    padding-top: 30px;
    padding-bottom: 30px;
    min-height: ${props => (props.isSuper30Page ? '20em' : '37em')};
  }
`

export const MapDescriptionSectionHeading = styled(Typo32PumpkinOrangeBNRI)`
  letter-spacing: 0.3px;
  line-height: normal;
  margin: 0px;
  margin-bottom: 0.32em;
  ${mobile} {
    font-size: 1.625em;
    margin-bottom: 0.385em;
  }
`

export const MapDescriptionSectionContent = styled(Typo16VeryLightPinkDR)`
  letter-spacing: normal;
  line-height: 1.56;
  ${mobile} {
    font-size: 0.875em;
  }
`
export const AddressContainer = styled('div')`
  display: flex;
  flex-direction: row;
`
export const AddressHeading = styled(Typo15PumpkinOrangeDR)`
  padding-right: 5px;
  line-height: 1.56;
`
export const Description = styled(Typo15VeryLightPinkDR)`
  line-height: 1.56;
`

export const AddressWrapper = styled('div')`
  padding-top: 10px;
`

export const ContactNoDescription = styled(Typo15VeryLightPinkDR)`
  line-height: 1.56;
  letter-spacing: 0.2px;
  cursor: pointer;
  &:hover {
    text-decoration: none;

    color: ${colors.veryLightPink};
  }
  &:focus {
    text-decoration: none;

    color: ${colors.veryLightPink};
  }
  ${mobile} {
    line-height: 20px;
  }
`



// WEBPACK FOOTER //
// ./src/components/IbcArcade/MapSection/MapDescriptionSection/styledComponents.js